import { render, staticRenderFns } from "./domain-section.html?vue&type=template&id=61bbe0b2&scoped=true&"
import script from "./domain-section.js?vue&type=script&lang=js&"
export * from "./domain-section.js?vue&type=script&lang=js&"
import style0 from "./domain-section.scss?vue&type=style&index=0&id=61bbe0b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bbe0b2",
  null
  
)

export default component.exports